import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

import { productionChildrenRoutes } from './productionChildrenRoutes';

const NotFoundPage = lazy(() => import('../../pages/404NotFound').then(module => ({ default: module.NotFound })));

const productionRoutes = {
  path: '/produccion',
  element: <Outlet />,
  errorElement: <NotFoundPage />,
  children: [
    ...productionChildrenRoutes.map(({ path, element }) => ({
      path,
      element,
    })),
  ],
};

export default productionRoutes;
